import { render } from "./gotv.vue?vue&type=template&id=0c51f78e&scoped=true"
import script from "./gotv.vue?vue&type=script&lang=js"
export * from "./gotv.vue?vue&type=script&lang=js"

import "./gotv.vue?vue&type=style&index=0&id=0c51f78e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c51f78e"]])

export default __exports__